import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAxiosInstance } from "../../services/Interceptor";
import { useEffect, useState } from "react";
import {
  resetPassword,
  verifyResetPassword,
} from "../../services/ContactPublicService";
import LoadingSpinner from "../../components/LoadingSpinner";
import PasswordInput from "../../components/common/PasswordInput";

export default function ResetPassword() {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();
  const apiInstance = useAxiosInstance();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    const url = window.location.href;
    const urlParams = new URLSearchParams(new URL(url).search);
    const accessCode = urlParams.get("AccessCode");
    const email = urlParams.get("email");
    setData({
      accessCode,
      email,
    });
  }, []);

  useEffect(() => {
    const verifyLink = async () => {
      try {
        await verifyResetPassword(apiInstance, data.accessCode, data.email);
      } catch (err) {
        alert("Invalid or expired link.");
        navigate("/sign-in");
      } finally {
        setLoading(false);
      }
    };
    if (data !== undefined) {
      setLoading(true);
      verifyLink();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleResetPassword = async (formData) => {
    if (formData.password !== formData.confirmPassword) {
      setError("confirmPassword", { message: "Passwords do not match." });
      return;
    }

    try {
      await resetPassword(
        apiInstance,
        data.accessCode,
        data.email,
        formData.password,
      );
      alert("Password has been reset successfully.");
      window.location.href = "/sign-in";
    } catch (err) {
      setError("password", { message: "Failed to reset password." });
    }
  };

  return loading ? (
    <div className="mt-10">
      <LoadingSpinner />
    </div>
  ) : (
    <div className="flex items-center justify-center min-h-screen hero-bg">
      <div className="bg-gray-900 bg-opacity-60 p-6 rounded-lg shadow-lg w-full max-w-xl">
        <h2 className="text-white block text-2xl mb-4 text-center">
          Reset Password
        </h2>
        <form onSubmit={handleSubmit(handleResetPassword)}>
          <PasswordInput
            label="New Password"
            name="password"
            register={register}
            validation={{ required: "New Password is required" }}
            placeholder="Enter new password..."
            errors={errors}
            autoComplete="new-password"
            inputClassName="w-full pr-10 border rounded px-3 py-2"
          />
          <PasswordInput
            label="Confirm Password"
            name="confirmPassword"
            register={register}
            validation={{ required: "Confirm Password is required" }}
            placeholder="Confirm new password..."
            errors={errors}
            autoComplete="new-password"
            inputClassName="w-full pr-10 border rounded px-3 py-2"
          />
          <button
            type="submit"
            className="bg-red-500 mt-4 text-white rounded px-4 py-2"
          >
            Reset
          </button>
        </form>
      </div>
    </div>
  );
}
